import { useContext } from 'react';

import OrganizationSettings from './OrganizationSettings';
import AnimateView from '@/react_app/components/BillingUsage/AnimateView';
import { SettingsContext as SettingsContextType } from '@/react_app/components/BillingUsage/contexts';

const SettingsUsageBillingSettings = () => {
	const settingsContext = useContext(SettingsContextType);
	if (!settingsContext) {
		return null;
	}

	return (
		<AnimateView>
			<OrganizationSettings
				users={settingsContext.users}
				billingEmailsConfig={settingsContext.billingEmailsConfig}
				organizationSettings={settingsContext.organizationSettings}
				emailsReceivingReceipts={settingsContext.emailsReceivingReceipts}
				onAddNewBillingContact={settingsContext.onAddNewBillingContact}
				getOrganizationSettings={settingsContext.getOrganizationSettings}
				onSaveBillingEmailsConfig={settingsContext.onSaveBillingEmailsConfig}
				onSaveOrganizationSettings={settingsContext.onSaveOrganizationSettings}
				isLoadingBillingEmailsConfig={settingsContext.isLoadingBillingEmailsConfig}
				isLoadingOrganizationSettings={settingsContext.isLoadingOrganizationSettings}
			/>
		</AnimateView>
	);
};

export default SettingsUsageBillingSettings;
